(function () {
    'use strict';

    const selector = '.js-recaptcha';
    const wrapper = document.querySelector(selector);

    // window.grecaptcha is added by https://www.google.com/recaptcha/api.js
    if (!wrapper || !window.grecaptcha) {
        return;
    }

    /**
     * @private onFormSubmit
     * @param {Event} evt - Submit Event
     * @description Validates recaptcha before submitting the form.
     */
    function onFormSubmit(evt) {
        // can't be check prior as the getResponse method gets added after DOM is loaded.
        if (window.grecaptcha.getResponse) {
            evt.preventDefault();

            const captachResponse = window.grecaptcha.getResponse();
            if (captachResponse.length > 0) {
                evt.target.removeEventListener('submit', onFormSubmit);
                evt.target.submit();
            }
        }
    }

    const form = wrapper.closest('form');
    form.addEventListener('submit', onFormSubmit);
}());
